export const CATEGORY_IMAGE_LIST: any = {
  'Home baker': 'home_baker.jpg', // Popular
  'Coffee & Tea': 'coffee.jpg',
  'Handyman': 'handyman.jpg', // Popular
  'Cleaner': 'cleaner.jpg', // Popular
  'Home Dining': 'Home Dining.png',
  'Dog Walking': 'Dog Walking.png', // Popular
  'Baby Sitting': 'Baby Sitting.png', // Popular
  'Hitch': 'hitch.png',
  'Fitness': 'Fitness.png', //New 
  'Hairdresser': 'Hairdresser-100.jpg', //New 
  'Home Tuition': 'Home Tuition.png', //New 
  'Pet Groomer': 'Pet Groomer-100.jpg', //New 
  'Donations': 'bless-100.jpg', //New 
  'Recomm': 'recommended-100.jpg', //New 
};
export const CATEGORY_POPULAR_IMAGE_LIST: any = {
  'Home baker': 'home_baker.jpg', // Popular
  'Handyman': 'handyman.jpg', // Popular
  'Cleaner': 'cleaner.jpg', // Popular
  'Dog Walking': 'Dog Walking.png', // Popular
  'Baby Sitting': 'Baby Sitting.png', // Popular
  'Home Tuition': 'Home Tuition.png', //New 
  'Donations': 'bless-100.jpg', //New 
  'Recomm': 'recommended-100.jpg', //New 
};

export const REGION_CATEGORY_IMAGE_LIST: Array<any> = [
  {
    name: 'north',
    image: 'region/NORTH_singapore_map.png',
  },
  {
    name: 'east',
    image: 'region/East_singapore_map (1).png',
  },
  {
    name: 'central',
    image: 'region/Central_singapore_map (1).png',
  },
  {
    name: 'west',
    image: 'region/West_singapore_map (1).png',
  },
  {
    name: 'north east',
    image: 'region/NORT EAST_singapore_map.png',
  },


];

export const REGION_SUB_CATEGORY_IMAGE_LIST: any = {
  queenstown: 'sub-region/queenstown.png',
  changi: 'sub-region/changi.png',
  eunos: 'sub-region/eunos.png',
  'jurong east': 'sub-region/jurong-east.png',
  redhill: 'sub-region/redhill.png',
  'tiong bahru': 'sub-region/tiong-bahru.png',
  'punggol': 'sub-region/punggol.png',
  'bendemeer': 'sub-region/bendemeer.png',
};

// export const MEMBER_SHOP_SUBCATEGORIES1: Array<any> = [
//   {
//     id: 1,
//     name: 'central|bukit merah',
//   },
//   {
//     id: 2,
//     name: 'central|bukit timah',
//   },
//   {
//     id: 3,
//     name: 'central|queenstown',
//   },
//   {
//     id: 4,
//     name: 'central|redhill',
//   },
//   {
//     id: 5,
//     name: 'central|tiong bahru',
//   },
//   {
//     id: 6,
//     name: 'central|kallang',
//   },
//   {
//     id: 7,
//     name: 'central|river valley',
//   },
//   {
//     id: 8,
//     name: 'central|novena',
//   },
//   {
//     id: 9,
//     name: 'central|orchard',
//   },
//   {
//     id: 10,
//     name: 'central|sentosa',
//   },


//   {
//     id: 11,
//     name: 'north|yishun',
//   },
//   {
//     id: 12,
//     name: 'north|woodlands',
//   },
//   {
//     id: 13,
//     name: 'north|sembawang',
//   },
//   {
//     id: 14,
//     name: 'north|lim chu kang',
//   },
//   {
//     id: 15,
//     name: 'north|mandai',
//   },
//   {
//     id: 16,
//     name: 'north|ang mo kio',
//   },
//   {
//     id: 17,
//     name: 'north|bishan',
//   },
//   {
//     id: 18,
//     name: 'north|toa payoh',
//   },


//   {
//     id: 19,
//     name: 'east|bedok',
//   },
//   {
//     id: 20,
//     name: 'east|paya lebar',
//   },
//   {
//     id: 21,
//     name: 'east|tampiness',
//   },
//   {
//     id: 22,
//     name: 'east|changi',
//   },
//   {
//     id: 23,
//     name: 'east|pasir ris',
//   },
//   {
//     id: 24,
//     name: 'east|marine parade',
//   },
	

//   {
//     id: 25,
//     name: 'west|bukit batok',
//   },
//   {
//     id: 26,
//     name: 'west|jurong east',
//   },
//   {
//     id: 27,
//     name: 'west|jurong west',
//   },
//   {
//     id: 28,
//     name: 'west|bukit panjang',
//   },
//   {
//     id: 29,
//     name: 'west|boon lay',
//   },
//   {
//     id: 30,
//     name: 'west|choa chu kang',
//   },
//   {
//     id: 31,
//     name: 'west|clementi',
//   },
//   {
//     id: 32,
//     name: 'west|pioneer',
//   },
//   {
//     id: 33,
//     name: 'west|tengah',
//   },
//   {
//     id: 34,
//     name: 'west|tuas',
//   },



//   {
//     id: 35,
//     name: 'north east|punggol',
//   },
//   {
//     id: 36,
//     name: 'north east|woodleigh',
//   },
//   {
//     id: 37,
//     name: 'north east|hougang',
//   },
//   {
//     id: 38,
//     name: 'north east|seletar',
//   },
//   {
//     id: 39,
//     name: 'north east|sengkang',
//   },
//   {
//     id: 40,
//     name: 'north east|serangoon',
//   },
//   {
//     id: 41,
//     name: 'north east|boon keng',
//   },
// ];

export const MEMBER_SHOP_CATEGORIES: Array<any> = Object.keys({ ...CATEGORY_IMAGE_LIST, ...CATEGORY_POPULAR_IMAGE_LIST }).map((key, index) => {
  if (key != 'Recommended')
    return {
      id: index + 1,
      name: key,
    }
});

export const PROFILE_CHARACTER_TYPE: Array<any> = ['eyes', 'headgear', 'special item', 'front weapon', 'back equipment', 'armor', 'pet', 'background'];

export const PROFILE_CHARACTER_TYPE_IMAGE_LIST: any = [
  { category: 'eyes', name: 'Face', image: 'profile-charactor/base-female.png', zIndex: 3 },
  { category: 'headgear', name: 'head', image: 'profile-charactor/head-helmet-man.png', zIndex: 4 },
  { category: 'armor', name: 'armor', image: 'profile-charactor/cloth-armored-machine-gunner.png', zIndex: 5 },
  { category: 'front weapon', name: 'front', image: 'profile-charactor/hand-rifle.png', zIndex: 6 },
  { category: 'special item', name: 'special', image: 'profile-charactor/head-wizard.png', zIndex: 7 },
  { category: 'back equipment', name: 'back eq', image: 'profile-charactor/hand-wand.png', zIndex: 2 },
  { category: 'pet', name: 'pet', image: 'profile-charactor/BG-VOLCANO.jpg' , zIndex: 8},
  { category: 'background', name: 'background', image: 'profile-charactor/BG-SUNNY.jpg', zIndex: 1 },
];
